module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event1-e13e7a492410eed2973bd1ab0f7529f9.jpg";